var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-window',{attrs:{"show-arrows":""}},_vm._l((_vm.produtoImages),function(item,index){return _c('v-window-item',{key:index},[_c('div',{staticClass:"d-flex justify-center align-stretch"},[_c('v-img',{attrs:{"src":item.img,"contain":"","height":_vm.imageHeight}})],1)])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }